import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './breadcrumb-menu.scss.js';

const MAX_VISIBLE = 6;
const HomeIcon = () => $ `<span class="material-symbols-outlined home-icon" aria-hidden="true">home</span>`;
const BackIcon = () => $ `<span class="material-symbols-outlined arrow-left" aria-hidden="true">arrow_back</span>`;
class BreadcrumbMenu extends s {
    constructor() {
        super(...arguments);
        this.breadcrumbs = [];
        this.rtl = false;
        this._expanded = false;
        this.isMobile = false;
        this.expandTimer = null;
        this.updateMediaQuery = () => {
            this.isMobile = window.innerWidth <= 1023;
        };
        this.onToggleExpand = () => {
            if (!this._expanded) {
                this._expanded = true;
                this.requestUpdate();
                if (this.expandTimer) {
                    clearTimeout(this.expandTimer);
                }
                this.expandTimer = window.setTimeout(() => {
                    this._expanded = false;
                    this.requestUpdate();
                }, 15000);
            }
        };
        this.onToggleExpandKeydown = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.onToggleExpand();
            }
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateMediaQuery();
        window.addEventListener('resize', this.updateMediaQuery);
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.updateMediaQuery);
        if (this.expandTimer) {
            clearTimeout(this.expandTimer);
            this.expandTimer = null;
        }
        super.disconnectedCallback();
    }
    get isRtl() {
        const dirAttr = this.getAttribute('dir');
        return this.rtl || dirAttr === 'rtl';
    }
    static sanitizeLabelHtml(label) {
        if (!label)
            return '';
        const parser = new DOMParser();
        const doc = parser.parseFromString(`<div>${label}</div>`, 'text/html');
        const container = doc.body.firstElementChild;
        if (!container)
            return '';
        const sanitizeNode = (node) => {
            var _a;
            if (node.nodeType === Node.TEXT_NODE) {
                return (_a = node.textContent) !== null && _a !== void 0 ? _a : '';
            }
            if (node.nodeType !== Node.ELEMENT_NODE) {
                return '';
            }
            const element = node;
            const tagName = element.tagName.toUpperCase();
            if (tagName === 'SCRIPT' || tagName === 'STYLE') {
                return '';
            }
            const childContent = Array.from(element.childNodes)
                .map(child => sanitizeNode(child))
                .join('');
            if (tagName === 'BR') {
                return '<br>';
            }
            if (BreadcrumbMenu.ALLOWED_INLINE_TAGS.has(tagName)) {
                const safeTag = tagName.toLowerCase();
                return `<${safeTag}>${childContent}</${safeTag}>`;
            }
            return childContent;
        };
        return Array.from(container.childNodes)
            .map(child => sanitizeNode(child))
            .join('');
    }
    static renderItem(item, isLast, index, isHiddenWhenCollapsed = false) {
        const textNode = item.relativeUrl && !isLast
            ? $ `<a class="breadcrumb-link" href="${item.relativeUrl}">${o(BreadcrumbMenu.sanitizeLabelHtml(item.pageName))}</a>`
            : $ `<span class="breadcrumb-text">${o(BreadcrumbMenu.sanitizeLabelHtml(item.pageName))}</span>`;
        const isHome = index === 0;
        return $ `<li class="item ${isLast ? 'is-current' : ''} ${isHiddenWhenCollapsed
            ? 'item-hidden-collapsed'
            : ''}" aria-current="${isLast ? 'page' : w}" data-item="${index}">${isHome ? HomeIcon() : w} ${textNode}</li>`;
    }
    static renderPrevNode(prev) {
        var _a;
        if (!prev)
            return w;
        if (prev.relativeUrl) {
            return $ `<a class="breadcrumb-link" href="${prev.relativeUrl}">${o(BreadcrumbMenu.sanitizeLabelHtml(prev.pageName))}</a>`;
        }
        return $ `<span class="breadcrumb-text">${o(BreadcrumbMenu.sanitizeLabelHtml((_a = prev.pageName) !== null && _a !== void 0 ? _a : ''))}</span>`;
    }
    static renderBackItem(prevIndex, prev) {
        const prevNode = BreadcrumbMenu.renderPrevNode(prev);
        return $ `<li class="item back" data-item="${prevIndex}">${BackIcon()} ${prevNode}</li>`;
    }
    renderEllipsis(isExpanded) {
        return $ `<li class="item ellipsis ${isExpanded ? 'ellipsis-expanded' : ''}" data-item="ellipsis"><button class="ellipsis-btn" type="button" aria-label="Show hidden breadcrumb items" aria-expanded="${isExpanded}" @click="${this.onToggleExpand}" @keydown="${this.onToggleExpandKeydown}">…</button></li>`;
    }
    visibleMobile(total) {
        if (total === 0)
            return [];
        const lastIndex = total - 1;
        if (total === 1) {
            return [BreadcrumbMenu.renderItem(this.breadcrumbs[0], true, 0)];
        }
        const prevIndex = lastIndex - 1;
        const prev = this.breadcrumbs[prevIndex];
        return [BreadcrumbMenu.renderBackItem(prevIndex, prev)];
    }
    visibleExpanded(total) {
        return this.breadcrumbs.map((it, i) => {
            const isLast = i === total - 1;
            return BreadcrumbMenu.renderItem(it, isLast, i);
        });
    }
    visibleCollapsed(total, isExpanded) {
        const items = [];
        items.push(BreadcrumbMenu.renderItem(this.breadcrumbs[0], false, 0));
        if (total > 1) {
            items.push(BreadcrumbMenu.renderItem(this.breadcrumbs[1], false, 1));
        }
        items.push(this.renderEllipsis(isExpanded));
        for (let i = 2; i < total - 2; i += 1) {
            items.push(BreadcrumbMenu.renderItem(this.breadcrumbs[i], false, i, !isExpanded));
        }
        if (total > 2) {
            items.push(BreadcrumbMenu.renderItem(this.breadcrumbs[total - 2], false, total - 2));
        }
        if (total > 0) {
            items.push(BreadcrumbMenu.renderItem(this.breadcrumbs[total - 1], true, total - 1));
        }
        return items;
    }
    getVisible() {
        const total = this.breadcrumbs.length;
        if (this.isMobile)
            return this.visibleMobile(total);
        if (total <= MAX_VISIBLE)
            return this.visibleExpanded(total);
        return this.visibleCollapsed(total, this._expanded);
    }
    render() {
        const { isRtl } = this;
        return $ `<nav class="breadcrumb" role="navigation" aria-label="Breadcrumb" dir="${isRtl ? 'rtl' : 'ltr'}"><ol class="list">${this.getVisible()}</ol></nav>`;
    }
}
BreadcrumbMenu.styles = css_248z;
BreadcrumbMenu.ALLOWED_INLINE_TAGS = new Set(['SUP', 'SUB', 'BR']);
__decorate([
    e({ type: Array })
], BreadcrumbMenu.prototype, "breadcrumbs", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], BreadcrumbMenu.prototype, "rtl", void 0);
__decorate([
    t()
], BreadcrumbMenu.prototype, "_expanded", void 0);
__decorate([
    t()
], BreadcrumbMenu.prototype, "isMobile", void 0);
__decorate([
    t()
], BreadcrumbMenu.prototype, "expandTimer", void 0);
customElements.define('breadcrumb-menu', BreadcrumbMenu);

export { BreadcrumbMenu };
